var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.components),function(widget,index){return _c(widget.type,{key:index,tag:"div",staticClass:"mb-6",attrs:{"data":widget,"override-background":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }